import React, { useEffect, useState } from "react";
import Preloader from "../elements/Preloader";
import HelmetReact from "../elements/HelmetReact";
import HeaderTwo from "../components/HeaderTwo";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/FooterTwo";
import Newsletter from "../components/Newsletter";
import ServiceInnerDetails from "../components/ServiceInnerDetails";

const ServiceConsultoria = () => {
  let [active, setActive] = useState(true);
  useEffect(() => { setTimeout(function () { setActive(false); }, 500); }, []);
  return (
    <>
      <HelmetReact title={"Consultoria em RH"} />
      <HeaderTwo />
      <Breadcrumb title="Consultoria em RH" />
      <ServiceInnerDetails serviceId="consultoria" />
      <FooterTwo />
    </>
  );
};
export default ServiceConsultoria;